import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Mission from "../components/Mission";
import HowItWorks from "../components/HowItWorks";
import Catalog from "../components/Catalog";
import CollectionStrip from "../components/CollectionStrip";
import CTABanner from "../components/CTABanner";
import Footer from "../components/Footer";
import ProductDialog from "../components/ProductDialog";
import api from "../lib/api";

function ProductFocus({ id }) {
    const navigate = useNavigate();
    const { data: product } = useQuery({
        queryKey: ["product", id],
        queryFn: async () => (await api.get(`/products/${id}`)).data,
        retry: false,
    });
    if (!product) return null;
    return <ProductDialog product={product} open onOpenChange={(o) => !o && navigate("/")} />;
}

export default function Landing() {
    const { id } = useParams();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [id]);

    return (
        <>
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Mission />
                <HowItWorks />
                <Catalog />
                <CollectionStrip />
                <CTABanner />
            </main>
            <Footer />
            {id && <ProductFocus id={id} />}
        </>
    );
}
